import React, { useEffect } from 'react'
import Phone from '../../Images/icon-phone.svg'
import Mail from '../../Images/icon-mail.svg'
import Driver from '../../Images/image-endscreen.jpg'
import './EndScreen.sass'
import { useState } from 'react'

export const EndScreen = (props) => {

	const [email] = useState(props.responsemail)

	useEffect(() => {
		setTimeout(() => {
			sessionStorage.clear()
			console.log('Storage cleared');
		}, 1000)
	}, [])
	
	return (
		<div className="no__endscreen">
			<h1 className="no__containerline">Vielen Dank für Ihre Bestellung</h1>
			<div className="no__endcontainer">
				<div className="no__endcontent">
					<h3 className='no__blue'>Eine Bestellbestätigung wurde an <strong>{props.email}</strong> gesendet</h3>
					<p><strong>Bei Fragen wenden Sie sich gerne an:</strong></p>
					<a href={`tel: ${props.tel}`}><img src={Phone} alt=""/> {props.tel}</a>
					<a href={`mailto: ${email}`}><img src={Mail} alt=""/> {email}</a>
				</div>
				<div className="no__endimage">
					<img src={Driver} alt="LKW Fahrer" />
				</div>
			</div>
		</div>
	)
}
